import GemMeterBaseRule from '../GemMeterBaseRule';
import { MISSING_LINK } from '../../../constants/rulesConstants';

export default class FormLinkRule extends GemMeterBaseRule {
  static ruleId = MISSING_LINK.id;

  static validate(selector: string) {
    const element = GemMeterBaseRule.getElement(selector);
    if (!element) {
      return false;
    }

    const { editLink } = (element as HTMLElement).dataset;

    return !!(editLink && editLink.length > 0);
  }
}
